// src/features/rrhh/dashboard/pages/DashboardPage.jsx
import { Stack } from "@mui/material";

import DashboardMainSection from "../components/DashboardMainSection";

export default function DashboardPage() {
  return (
    <Stack
      spacing={2}
      sx={{
        pt: 2,
        pr: 3,
        pl: 0,
        width: "100%",
        minWidth: 0,
        overflowX: "hidden",
      }}
    >
      <DashboardMainSection />
    </Stack>
  );
}
